export async function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  try {
    return await fetch(input, init)
  } catch (error) {
    if (error instanceof TypeError) {
      throw new Error('서버에 연결할 수 없습니다. 페이지를 새로고침하거나 잠시 후 다시 시도해 주세요.')
    }
    throw error
  }
}
